/* eslint-disable import/prefer-default-export */

// eslint-disable-next-line import/extensions
import { RoiCalculation } from "../../../graphql/types";
// eslint-disable-next-line import/extensions
import { useRoiCalculationFetch } from "./useRoiCalculationFetch";

interface UseRoiCalculationSnapshotArgs {
  customerId?: string;

  baselineReference?: string | null;
  interventionReference?: string;
}

interface UseRoiCalculationSnapshotResult {
  calculation: RoiCalculation | null;

  loading: boolean;
  /** The lookup failed — the reason is logged, never surfaced as copy here. */
  failed: boolean;
}

export const useRoiCalculationSnapshot = ({
  customerId,
  baselineReference,
  interventionReference,
}: UseRoiCalculationSnapshotArgs): UseRoiCalculationSnapshotResult => {
  const state = useRoiCalculationFetch({
    customerId,
    baselineReference,
    interventionReference,
  });

  return {
    calculation: state.status === "loaded" ? state.calculation : null,
    loading: state.status === "idle" || state.status === "loading",
    failed: state.status === "failed",
  };
};
